var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Container',{class:_vm.$style.container},[_c('Card',{class:_vm.$style.chartCard},[_c('OsEventsGraph',{attrs:{"customChartHeight":220,"minTitle":"","showOsFilter":"","showTimeFrame":""}})],1),_c('Card',{class:_vm.$style.releasesCard},[_c('Card',{class:_vm.$style.cardFullHeight},[_c('OsReleasePatchTabs',{attrs:{"showTitle":""}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }